module.exports = __webpack_public_path__ + "static/images/pocket.2282c36.png";